import { LibraryPage } from '@/components/library/LibraryPage.web';

export default LibraryPage;
